import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "assets-detail-container" }
const _hoisted_2 = {
  key: 0,
  class: "stock-detail"
}
const _hoisted_3 = {
  key: 1,
  class: "fund-detail"
}
const _hoisted_4 = {
  key: 2,
  class: "bond-detail"
}
const _hoisted_5 = {
  key: 3,
  class: "sps-detail"
}

import { computed, ref } from 'vue'
import AccountTypeTab from '@/components/holdings/AccountTypeTab.vue'
import StockDetail from '@/components/holdings/StockDetail.vue'
import FundDetail from '@/components/holdings/FundDetail.vue'
import BondDetail from '@/components/holdings/BondDetail.vue'
import SpsDetail from '@/components/holdings/SpsDetail.vue'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'AssetsDetail',
  setup(__props) {

const store = useStore()

const accountTypeActive = computed(() => {
  return store.state.holdings.accountTypeActive
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AccountTypeTab, null, {
      default: _withCtx(() => [
        (accountTypeActive.value.value === 'STOCK')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(StockDetail)
            ]))
          : _createCommentVNode("", true),
        (accountTypeActive.value.value === 'FUND')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(FundDetail)
            ]))
          : _createCommentVNode("", true),
        (accountTypeActive.value.value === 'BOND')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(BondDetail)
            ]))
          : _createCommentVNode("", true),
        (accountTypeActive.value.value === 'SPS')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(SpsDetail)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})